import React, { useState,useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PostRequestAPI } from "../../Api/PostRequest";
import UploadFile from "../../Api/UploadFile";
import FileUploader from "../CampaignManagement/Component/FileUploader";
import { MOSAIC_APPROVED_URL, MOSAIC_UPDATE_API } from "../Shared/constant";
import { validateFormData } from "../Shared/utils";
const MosaicEdit = () => {
  const { accessToken } = useSelector((state) => state.personalReducers);
    const { mosaicRequestList } = useSelector((state) => state.campaignReducers);
  
  const param = useParams();
  const navigate = useNavigate();

  const matchData = mosaicRequestList?.data?.find((user) => user.id === param?.id);


  const [formData, setFormData] = useState({source_image: "",mosaic_image: ""});
  const [uploadingFiles, setUploadingFiles] = useState({source_image: false,mosaic_image: false});
  const [error, setError] = useState({source_image: "",mosaic_image: ""});
  const [load, setLoad] = useState(false);

  const validationRules = {
    source_image: { required: true, label: "Source Image" },
    mosaic_image: { required: true, label: "Mosaic Image" },
  };
  useEffect(() => {
    if(param?.id){
         setFormData({
            source_image:matchData?.source_image,
            mosaic_image:matchData?.mosaic_image 
         })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param?.id])
  

  const handleFileUpload = async (file, type, index) => {
    setUploadingFiles((prevState) => ({
      ...prevState,
      [type]: true,
    }));

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      const response = await UploadFile(accessToken, formDataUpload);
      const payloadResponse = {
        file_url_400: response?.file_url_400,
        file_url_700: response?.file_url_700,
        view_file_url: response?.view_file_url,
      };
      if (response) {
        setFormData((prev) => ({
          ...prev,
          [type]: payloadResponse,
        }));
        setError((prev) => ({
          ...prev,
          [type]: "",
        }));
      }
    } catch (error) {
      console.error("Upload failed", error);
    } finally {
      setUploadingFiles((prevState) => ({
        ...prevState,
        [type]: false,
      }));
    }
  };
  const handleDeleteFile = (type, index) => {
    setFormData((prev) => ({
      ...prev,
      [type]: "",
    }));
  };

  const onSubmit = async (e) => {
    const valid = validateFormData(formData, validationRules);
    if (Object.values(valid)?.length === 0) {
        setLoad(true)
      const payload = {
        request_id: param?.id,
        source_image: {
          view_file_url: formData?.source_image?.view_file_url,
          file_url_400: formData?.source_image?.file_url_400,
          file_url_700: formData?.source_image?.file_url_700,
        },
        mosaic_image: {
          view_file_url: formData?.mosaic_image?.view_file_url,
          file_url_400: formData?.mosaic_image?.file_url_400,
          file_url_700: formData?.mosaic_image?.file_url_700,
        },
      };
        const response = await PostRequestAPI(MOSAIC_UPDATE_API,payload,accessToken,false);
        if (response?.status === 200) {
            toast.success(response?.data?.msg);
            setLoad(false)
            navigate(MOSAIC_APPROVED_URL, { replace: true })
        } else {
            toast.error(response?.data?.error);
            setLoad(false)
        }
    } else {
      setError((error) => ({
        ...error,
        ...valid,
      }));
    }
  };

  return (
    <>
      <ul className="tabcomnsection">
        <li className={"active text-capitalized"}>Upload mosaic Image</li>
        <div className="tabheadebuttns">
          <Button className="savchanges" onClick={onSubmit} disabled={load}>
          {load&&(<Spinner />)}  Save
          </Button>
          <Link className="btn savchanges linksmanage" to={MOSAIC_APPROVED_URL}>
            Back
          </Link>
        </div>
      </ul>
      <FileUploader
        label="Upload Source Image"
        name="source_image"
        type="source_image"
        value={formData.source_image}
        onUpload={(file) => handleFileUpload(file, "source_image")}
        onDelete={() => handleDeleteFile("source_image")}
        uploadFileLoader={uploadingFiles.source_image}
        isMultiple={false}
        error={error?.source_image}
        required
        isLimit={20}
      />
      <FileUploader
        label="Upload Mosaic Image"
        name="mosaic_image"
        type="mosaic_image"
        value={formData.mosaic_image}
        onUpload={(file) => handleFileUpload(file, "mosaic_image")}
        onDelete={() => handleDeleteFile("mosaic_image")}
        uploadFileLoader={uploadingFiles.mosaic_image}
        isMultiple={false}
        error={error?.mosaic_image}
        required
        isLimit={20}

      />
    </>
  );
};
export default MosaicEdit;
